import axios from 'axios';
import { API_BASE_URL } from 'src/constants/config.js';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const jwtToken = localStorage.getItem('jwtToken');

  if (jwtToken) {
    config.headers.Authorization = `Bearer ${jwtToken}`;
  }

  return config;
});

api.interceptors.response.use((response) => {
  if (response.data.status === 'Login error' && response.data.error === true) {
    window.location.href = '/auth/login';
  }

  return response;
});

export default api;
